import { useEffect, useState, useCallback } from 'react';

/**
 * 根据正文滚动位置计算「当前所在章节」
 * @param {object} editor tiptap 编辑器
 * @param {Array} outline useOutline 的结果
 * @param {React.RefObject<HTMLElement>} containerRef 正文滚动容器
 * @returns {[string|null, Function]} [activeId, setActiveId]
 */
export function useActiveHeading(editor, outline, containerRef) {
    const [activeId, setActiveId] = useState(null);

    const compute = useCallback(() => {
        const container = containerRef?.current;
        if (!editor?.view || !container || outline.length === 0) return;
        const containerTop = container.getBoundingClientRect().top;
        const threshold = containerTop + container.clientHeight * 0.3;
        let current = outline[0].id;
        for (let i = 0; i < outline.length; i += 1) {
            const item = outline[i];
            let dom = null;
            try {
                dom = editor.view.nodeDOM(item.pos);
            } catch (error) {
                dom = null;
            }
            if (!(dom instanceof Element)) continue;
            if (dom.getBoundingClientRect().top <= threshold) {
                current = item.id;
            } else {
                break;
            }
        }
        setActiveId(current);
    }, [editor, outline, containerRef]);

    useEffect(() => {
        const container = containerRef?.current;
        if (!container) return undefined;
        let frame = null;
        const onScroll = () => {
            if (frame) return;
            frame = window.requestAnimationFrame(() => {
                frame = null;
                compute();
            });
        };
        compute();
        container.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            container.removeEventListener('scroll', onScroll);
            if (frame) window.cancelAnimationFrame(frame);
        };
    }, [compute, containerRef]);

    return [activeId, setActiveId];
}
